import React, { useEffect, useState } from 'react'
import InputCelPhone from 'components/Checkout/CheckoutSteps/Identificacion/InputCelPhone';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import { actionsType } from 'config/constants';
import CartAction from 'actions/Cart';
import Loader from 'components/Loader';
import NewRelicService from 'services/NewRelic';
import { formatRut } from 'utils';

import style from './style.scss';//NOSONAR

const FormUpdateClient = (props) => {
    const [user, setUser] = useState(null);
    const [phoneIsValid, setPhoneIsValid] = useState(false);
    const [phoneValue, setPhoneValue] = useState('');
    const [isLoading, setLoading] = useState(false);


    useEffect(() => {
        const { payload } = props;
        if (payload) {
            setUser(payload.value ? payload.value.user : null);
            setPhoneValue((payload.value && payload.value.user ? payload.value.user.phone : ''))

        }
    }, [props.payload])

    const phoneValid = (phone) => { 
        isValid(true);
        if (phone) {
            setPhoneValue(phone)
        }
    }

    const isValid = (valid) => {
        setPhoneIsValid(valid);
    }

    const onSubmit = (event) => {
        event.preventDefault();
        onClickSubmitContinue();
    };

    const onClickSubmitContinue = () => {
        NewRelicService.sendPageAction({
            action: 'updateClientSubmit',
            payload: {
                status: 'init'
            }
        });
        if (phoneValue) {
            let updateUser = {
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                document: user.document,
                documentType: "RUT",
                phone: phoneValue,
                corporateName: null,
                tradeName: null,
                corporateDocument: null,
                stateInscription: null,
                corporatePhone: null,
                isCorporate: false,
                profileCompleteOnLoading: false,
                profileErrorOnLoading: false,
                customerClass: null
            }
            setLoading(true);
            CartAction.setProfileData(updateUser).then(() => {
                setLoading(false);
                NewRelicService.sendPageAction({
                    action: 'updateClientSubmit',
                    payload: {
                        status: 'success'
                    }
                });
                goBack();
            });
        }
    }

    const goBack = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.UPDATE_CLIENT_CLOSE),0);
    }

    return (
        <>
            <div className="new-modal-container">
                <div className="new-modal-title-wrap"><h3 className="new-modal-title">Datos Personales</h3></div>
                <div className='new-modal-scroll'>
                    {isLoading && <div className="update-client-loader"><Loader /></div>}
                    <div className="update-client-container">
                        <div className="update-box-conteiner">
                            <div className="update-box-wrapper">
                                <span className="update-client-name">Nombre</span>
                                <span
                                    className="update-client-value">{`${user && user.firstName ? user.firstName : ''} ${user && user.lastName ? user.lastName : ''}`}</span>
                            </div>
                            <div className="update-box-wrapper">
                                <span className="update-client-name">Mail de contacto</span>
                                <span className="update-client-value">{user && user.email ? user.email : ''}</span>
                            </div>
                            <div className="update-box-wrapper">
                                <span className="update-client-name">RUT</span>
                                <span className="update-client-value">{user && user.document ? formatRut(user.document) : ''}</span>
                            </div>
                        </div>
                        <div className="client-information-line"></div>
                        <div className="client-phone-wrap">
                            <span className="client-information-phone required">Télefono</span>
                            <div className="phone-information-wrap">
                                <InputCelPhone  phone={phoneValue} callback={phoneValid} callbackisValid={isValid} callbackOnkeyPress={onSubmit}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-actions">
                    <div className="card-buttons-container">
                        <button className="secundary-btn" onClick={() => goBack()}>Cancelar</button>
                        <button className={phoneIsValid ? 'primary-btn' : 'disabled-btn'} onClick={()=> onSubmit(event) }>Guardar</button>
                    </div>
                </div>
            </div>
        </>

    )
}

FormUpdateClient.propTypes = {
    payload: PropTypes.object
};

export default FormUpdateClient;
